export default __webpack_public_path__ + "static/not-found-d8237afed897b379cbfb3bccc6786814.svg";